import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { Declaration, DeclarationGoods } from '@e-origin/shared';

import { useSaveGoodsItemDocuments } from '@hooks/declaration';
import { DeclarationViewGoodLVFormValues, declarationViewGoodLVSchema } from './validateViewGoodLVDocumentsForm';

interface UseDeclarationViewGoodLVFormProps {
  declaration: Declaration;
  goodDetails: DeclarationGoods;
  onHide(): void;
}

export const useDeclarationViewGoodLVForm = ({ declaration, goodDetails, onHide }: UseDeclarationViewGoodLVFormProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const saveGoodsItemDocuments = useSaveGoodsItemDocuments();

  const form = useForm<DeclarationViewGoodLVFormValues>({
    initialValues: {
      _id: goodDetails?._id || '',
      documents: goodDetails?.documents || {
        previousDocuments: [],
        supportingDocuments: [],
        additionalReference: [],
        additionalInformation: [],
        transportDocuments: [],
        additionalFiscalReference: [],
      },
    },
    validate: zodResolver(declarationViewGoodLVSchema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values) => {
    setIsSaving(true);
    try {
      await saveGoodsItemDocuments.mutateAsync({
        declarationId: declaration._id,
        goodsItemId: goodDetails._id,
        documents: values.documents,
      });
      onHide();
    } finally {
      setIsSaving(false);
    }
  };

  return {
    form,
    onSubmit,
    isSaving,
  };
};
